import axios from 'axios';

const getSameOriginApiUrl = () => {
    const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    return `${window.location.origin}${publicUrl}/`;
};

const serverVars = {
    apiUrl: process.env.REACT_APP_API_URL || getSameOriginApiUrl(),
};

const localVars = {
    apiUrl: process.env.REACT_APP_API_URL || 'https://localhost:7148/',
};

const getDefaultConfig = () => {
    return process.env.NODE_ENV === 'production' ? serverVars : localVars;
};

export function getConfiguration() {
    let config = getConfigFromApi();

    if (!config) {
        console.log("getDefaultConfig");
        config = getDefaultConfig();
    }
    return config;
};

export function performConfigRequest() {
    const getUrl = (endpoint) => {
        const BASE_URL = getDefaultConfig().apiUrl;
        return BASE_URL + 'api/' + endpoint + '/';
    };

    let url = getUrl(ENDPOINTS.getConfig);

    return axios.get(url)
        .then(res => {
            if (!res || !res.data || res.data.length === 0) {
                throw new Error("No se pudo cargar la configuracion del sitio. Por favor intenta nuevamente.<br /><br />Si el problema persiste contacta al administrador del sistema");
            }

            let config = {};
            res.data.forEach(x => {
                config[x.key] = AES_Decode(x.value);
                if ((/^(true|false)$/i).test(config[x.key])) config[x.key] = config[x.key].toLowerCase() === "true";
            });

            document.portalInscripcion = { config: config };
            return config;
        });
}

function getConfigFromApi() {
    if (document.portalInscripcion?.config)
        return document.portalInscripcion.config;

    performConfigRequest();
};

const AES_Decode = (base64_text) => {
    const key = "erxt7zths0qdaf9bfyu5psjg8hkld1aa";
    window.GibberishAES.size(256);
    return window.GibberishAES.aesDecrypt(base64_text, key);
}

export const ENDPOINTS = {
    getInformation: 'student/GetStudentInformation',
    active: 'student/ActivateStudent',
    enroll: 'student/EnrollStudent',
    contactUs: 'payment/GetContactUsLinks',
    getPaymentReference: 'payment/GetPaymentReference',
    getSchedule: 'schedule/GeneratePDF',
    getPaymentSSO: 'payment/PaymentSSO',
    getConfig: 'config/Get',
    getMe: 'student/Me',
};